<mat-progress-bar mode="indeterminate" id="progressBar"></mat-progress-bar>
<router-outlet></router-outlet>